
import { useEffect, useState } from "react";
import PreLoader from "../../components/preloader/PreLoader";

const Reviews = () => {
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true;
    document.body.appendChild(script);
    setLoading(false);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <PreLoader />
        </>
      ) : (
        <div className="container my-5">
          <div className="row">
            <div className="col-12">
              <div
                className="elfsight-app-7983b291-b7d4-4856-b3b7-82e1f40c7376"
                data-elfsight-app-lazy
              ></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Reviews;
